import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { XCircle, RefreshCw, Home } from "lucide-react";

export default function PaymentCancel() {
  const { lang } = useI18n();
  const msgs = {
    fr: { title: "Paiement annulé", sub: "Votre don n'a pas été prélevé. Vous pouvez réessayer à tout moment — chaque geste compte.", retry: "Reprendre mon don", home: "Retour à l'accueil" },
    en: { title: "Payment cancelled", sub: "No charge was made. You can try again anytime — every gesture matters.", retry: "Resume my donation", home: "Back to home" },
    de: { title: "Zahlung abgebrochen", sub: "Es wurde keine Zahlung vorgenommen. Sie können jederzeit erneut spenden.", retry: "Spende fortsetzen", home: "Zur Startseite" },
  };
  const m = msgs[lang] || msgs.fr;
  return (
    <div className="min-h-screen bg-ivory grid place-items-center px-5" data-testid="payment-cancel">
      <div className="max-w-lg w-full bg-white rounded-3xl p-10 text-center shadow-xl border-t-4 border-warm-orange">
        <XCircle className="mx-auto text-warm-orange" size={72}/>
        <h1 className="font-display text-4xl text-deep-blue mt-4">{m.title}</h1>
        <p className="text-deep-blue/70 mt-3">{m.sub}</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/faire-un-don" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold" data-testid="retry-donation">
            <RefreshCw size={18}/> {m.retry}
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-deep-blue text-deep-blue font-semibold" data-testid="cancel-home">
            <Home size={18}/> {m.home}
          </Link>
        </div>
      </div>
    </div>
  );
}
